import { useEffect, useRef } from "react";
import { toast } from "sonner";
import { useModuleAccess } from "@/hooks/useModuleAccess";

/** Lệnh in gốc của trình duyệt — PrintDialog (đã tự kiểm quyền In theo loại chứng từ) gọi thẳng hàm này */
let nativePrint: (() => void) | null = null;
export function printBypassGuard() {
  (nativePrint || window.print.bind(window))();
}

/**
 * Chốt chặn quyền In cho mọi nút gọi window.print() (04/11/2026): kiểm quyền In của module màn đang mở trên bảng
 * phân quyền; chưa có quyền thì báo, không mở hộp in. Gắn một lần ở MainLayout.
 * Trình in theo loại chứng từ (PrintDialog) và hộp in tem dùng react-to-print kiểm riêng (usePrintGuard).
 */
export function PrintPermissionGuard() {
  const access = useModuleAccess();
  const ref = useRef(access);
  ref.current = access;

  useEffect(() => {
    if (!nativePrint) nativePrint = window.print.bind(window);
    const guarded = () => {
      if (!ref.current.canPrint) {
        toast.error(`Bạn chưa có quyền In ở ${ref.current.moduleName}. Liên hệ Admin để được cấp quyền trên bảng Phân quyền.`);
        return;
      }
      nativePrint!();
    };
    window.print = guarded;
    return () => {
      if (window.print === guarded && nativePrint) window.print = nativePrint;
    };
  }, []);

  return null;
}
